import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthFullScreenEmailSent() {
	return <AuthShell variant="full-screen"><AuthForm variant="full-screen" mode="email-sent" /></AuthShell>;
}

export default AuthFullScreenEmailSent;
